import { render, staticRenderFns } from "./QuickTipsDuplicateSearch.vue?vue&type=template&id=7bc1111c&scoped=true&"
import script from "./QuickTipsDuplicateSearch.vue?vue&type=script&lang=js&"
export * from "./QuickTipsDuplicateSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc1111c",
  null
  
)

export default component.exports